import React, { Component } from 'react';

export default class FacebookLogin extends Component {
  constructor(props) {
    super(props);
    this.checkLoginState = this.checkLoginState.bind(this);
    this.clickHandler = this.clickHandler.bind(this);
  }

  componentDidMount() {

  }

  responseApi (authResponse) {
    FB.api('/me', { fields: this.props.fields }, (me) => { // eslint-disable-line no-undef
      me.accessToken = authResponse.accessToken;
      this.props.responseHandler(me);
    });
  };

  checkLoginState (response) {
    if (response.authResponse) {
      this.responseApi(response.authResponse);
    } else {
      if (this.props.responseHandler) {
        this.props.responseHandler({ status: response.status });
      }
    }
  };

  clickHandler () {
    FB.login(this.checkLoginState, { scope: this.props.scope }); // eslint-disable-line no-undef
  };

  render() {
    const {
      socialId, xfbml, cookie, version, language, fields, responseHandler,
      children, buttonText, ...props
    } = this.props;

    return (
      <div>
      <button {...props} onClick={this.clickHandler} style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
      <i className="fa fa-facebook"></i>
        {children}
        {buttonText}
      </button>
      </div>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/FacebookLogin.js
 **/